import { ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "./ThemeProvider";
import { WagmiProvider } from "wagmi";
import { wagmiConfig } from "@/config/wagmi";

const queryClient = new QueryClient();

interface Props {   
    children: ReactNode
}

export function Providers({ children }: Props) {
    return (
        <WagmiProvider config={wagmiConfig}>
            <QueryClientProvider client={queryClient}>
                <ThemeProvider defaultTheme="light" storageKey="ui-theme">
                    {children}
                </ThemeProvider>
            </QueryClientProvider>
        </WagmiProvider>
    )
}